import { Component, OnInit, inject } from '@angular/core'
import { ActivatedRoute, ParamMap } from '@angular/router'

import { scrollTo } from '../../helpers/utils'
import { Release, ReleaseService } from '../release.service'

@Component({
  standalone: false,
  templateUrl: './release.component.html',
  styleUrls: ['./release.component.scss'],
})
export class ReleaseComponent implements OnInit {
  private route = inject(ActivatedRoute)
  private releaseService = inject(ReleaseService)

  public release: Release

  public scrollTo = scrollTo

  public ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const targetVersion = params.get('version')
      this.release = this.releaseService.getVersion(targetVersion)
    })
  }

  public parseDate(date: string): string {
    date.replaceAll('.', '/')
    const parsedDate = new Date(date.substring(0, 10))
    return parsedDate.toDateString()
  }
}
